import { render, staticRenderFns } from "./FacultiesAdmin.vue?vue&type=template&id=a8dc9c88&scoped=true&"
import script from "./FacultiesAdmin.vue?vue&type=script&lang=js&"
export * from "./FacultiesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FacultiesAdmin.vue?vue&type=style&index=0&id=a8dc9c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dc9c88",
  null
  
)

export default component.exports